import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Prize } from '../../../shared/interfaces/prize';

@Component({
    selector: 'app-prize-summary',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './prize-summary.component.html',
    styleUrl: './prize-summary.component.scss',
})
export class PrizeSummaryComponent {
    @Input({ required: true }) public prize: Prize | undefined;
}
